document.addEventListener("DOMContentLoaded", () => {

  const swipers = document.querySelectorAll(".js-customizable-swiper");

  swipers.forEach((el) => {

    const slidesPerView = Number(el.dataset.slidesPerView) || 1;
    const spaceBetween = Number(el.dataset.spaceBetween) || 0;
    const loop = el.dataset.loop === "true";
    const speed = Number(el.dataset.speed) || 300;
    const autoplayDelay = Number(el.dataset.autoplay) || 0;

    const breakpoints = {
      320: {
        slidesPerView: Number(el.dataset.mobileSlides) || 1
      },
      768: {
        slidesPerView: Number(el.dataset.tabletSlides) || 2
      },
      1024: {
        slidesPerView: Number(el.dataset.desktopSlides) || 4
      },
      1280:{
        slidesPerView: Number(el.dataset.desktopSlideslg) || slidesPerView
      }
    };

    const swiperOptions = {
      slidesPerView,
      spaceBetween,
      loop,
      speed,
      breakpoints,
      scrollbar: {
        el: el.querySelector(".swiper-scrollbar"),
        draggable: true
      },
      navigation: {
        nextEl: el.parentElement.querySelector(".js-swiper-next"),
        prevEl: el.parentElement.querySelector(".js-swiper-prev")
      }
    };

    if (autoplayDelay > 0) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }

    new Swiper(el, swiperOptions);

  });

});